import { User, Category, Media } from "../models";
import { APIVersion, AuthenticatedRequest, HTTPMethod } from "../requests/request";
import { Album } from "../models/album";
import { Tag } from "../models/tag";

export class API {

    /**
     * Fetches the user's create
     * @returns {Promise<Media[]>} The Promise contains an APIError if rejected
     */
    public static getCrate(): Promise<Media[]> {
        let apiRequest = new AuthenticatedRequest<Media>('/crate', HTTPMethod.GET, APIVersion.v1_2);
        return apiRequest.send(Media).then((response) => {
            return <Media[]>response.data;
        });
    }

    /**
 * @returns {Promise<{id: string}>} The Promise contains an APIError if rejected
 */
    public static getCrateDownloadId(type?: 'audio' | 'video' | 'all', category?: string, overrideAPIUrl?: string, idempotentToken?: string): Promise<{ id: string }> {
        let apiRequest = new AuthenticatedRequest<{ id: string }>('/crate/download', HTTPMethod.GET, APIVersion.v1_2, { type, category, idempotentToken });
        apiRequest.overrideAPIUrl = overrideAPIUrl;
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    /**
        * @returns {Promise<[]>} The Promise contains an APIError if rejected
    */
    public static clearCrate(type?: 'audio' | 'video' | 'all', category?: string): Promise<Media[]> {
        let apiRequest = new AuthenticatedRequest<Media>('/crate', HTTPMethod.DELETE, APIVersion.v1_2, { type, category });
        return apiRequest.send(Media).then((response) => {
            return <Media[]>response.data;
        });
    }

    /**
     * @returns {Promise<{id: string}>} The Promise contains an APIError if rejected
     */
    public static getCrateDownloadLink(id: string): Promise<{ url: string }> {
        let apiRequest = new AuthenticatedRequest('/crate/download/' + id, HTTPMethod.GET, APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return response.data;
        })
    }

    /**
     * Adds to the user's create
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    public static addToCrate(media_id: string): Promise<Media[]> {
        let apiRequest = new AuthenticatedRequest<Media>('/crate/' + media_id, HTTPMethod.POST, APIVersion.v1_2);
        apiRequest.preventNotVerifiedHandler = true
        apiRequest.preventInvalidSubscriptionHandler = true
        return apiRequest.send(Media).then((response) => {
            return response.data
        });
    }

    /**
     * Adds to the user's create
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    public static addPlaylistToCrate(playlist_id: string): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/crate/playlist/' + playlist_id, HTTPMethod.POST, APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }

    /**
     * Adds to the user's create
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    public static addSetPlaylistToCrate(set_id: string): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/crate/curated_set/' + set_id, HTTPMethod.POST, APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }

    /**
     * Removes from the user's create
     * @returns {Promise<Media[]>} The Promise contains an APIError if rejected
     */
    public static removeFromCrate(media_id: string): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/crate/' + media_id, HTTPMethod.DELETE, APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }

}



// WEBPACK FOOTER //
// ./src/api/src/endpoints/crate.ts